import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { NavigationEnd, Router, Event } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { User } from '@nousmedis/guard-types/dist/frontend';
import { Catalog } from '@nousmedis/cc-types';
import { CatalogService } from 'app/modules/catalog-cloud/services/catalog.service';
import { FascicleService } from 'app/modules/catalog-cloud/services/fascicle.service';
import { UserService } from 'app/modules/user/services/user.service';
import { MenuItem } from 'primeng/api';
import { filter, firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {
    user: User;
    constructor (private userService: UserService,
        private translate: TranslateService,
        private fascicleService: FascicleService,
        private catalogService: CatalogService,
        private router: Router,

    ) {
        this.user = userService.getCurrentUser();

    }

    model: any[] = [];

    ngOnInit() {
        this.router.events.subscribe((event: Event) => {

            if (event instanceof NavigationEnd) {
                // console.log("NAvigation end", event);
                // console.log(event.url);

                if (event.url.includes('catalog') && (event.url.includes('fascicle/'))) {
                    const idCat = this.getIdCatalogFromUrl(event.url);
//                    console.log("ID CATALOG", idCat);
                    if (idCat)
                        this.setMenuFascicle(idCat);

                    else
                        this.setMenuItemsGeneric();

                }
                else {
                    this.setMenuItemsGeneric();
                }

            }
        });

    }

    async getLabel(label: string) {
        return firstValueFrom(this.translate.get(label)).then((res: string) => {
            //console.log(res);
            return res;
        });
    }

    async setMenuItemsGeneric() {
        this.model = [

            {
                label: 'CatalogCloud',
                icon: 'pi pi-home',
                items: [
                    {
                        label: await this.getLabel('CATALOGS'),
                        icon: 'pi pi-fw pi-home',
                        routerLink: ['/']
                    },
                    {
                        label: await this.getLabel('CATALOG.CREATE'),
                        icon: 'pi pi-fw pi-plus',
                        routerLink: ['/catalog/new']
                    },
                    {
                        label: await this.getLabel('PAGE.TEMPLATE_LIST'),
                        icon: 'pi pi-fw pi-list',
                        routerLink: ['/page-templates/list']
                    },
                    // {
                    //     label: await this.getLabel('BACKUPS_ADD'),
                    //     icon: 'pi pi-fw pi-file-export',
                    //     routerLink: ['/backups/']
                    // }

                    //http://localhost:3010/api/v1/jobs/run/67b5c25b14b2904282354e76
                    

                ]
            },
            {
                label: (this.user?.name || '') + " " + (this.user?.surname || ''),
                icon: 'pi pi-fw pi-user',
                items: [
                    {
                        label: 'Cerrar sesión',
                        icon: 'pi pi-fw pi-sign-out',
                        command: () => {
                            this.userService.logOut(this.user);
                            window.location.href = '/login';
                        }

                    },
                ],
            },
        ];
    }

    async setMenuFascicle(idCatalog: string) {

        this.catalogService.getCatalog(idCatalog).subscribe(async (catalog: Catalog) => {
            let fascicles: MenuItem[] = [];
            fascicles.push({
                label: await this.getLabel('CATALOG.GO_TO_FASCICLE_LIST'),
                icon: 'fa fa-list',
                routerLink: ['/catalog/' + idCatalog + '/fascicles']
            });
            for (let fascicle of catalog.fascicles) {
                fascicles.push({
                    label: fascicle.name,
                    routerLink: ['/catalog/' + idCatalog + '/fascicle/' + fascicle.id]
                });
            }

            this.model = [
                {
                    label: 'CatalogCloud',
                    icon: 'pi pi-home',
                    items: [
                        {
                            label: await this.getLabel('CATALOGS'),
                            icon: 'pi pi-fw pi-home',
                            routerLink: ['/']
                        },
                        {
                            label: await this.getLabel('CATALOG.CREATE'),
                            icon: 'pi pi-fw pi-plus',
                            routerLink: ['/catalog/new']
                        },
                        {
                            label: await this.getLabel('PAGE.TEMPLATE_LIST'),
                            icon: 'pi pi-fw pi-list',
                            routerLink: ['/page-templates/list']
                        },
                        {
                            label: await this.getLabel('BACKUPS_ADD'),
                            icon: 'pi pi-fw pi-file-export',
                            routerLink: ['/backups/']
                        }

                    ]
                },
                {
                    label: catalog.name,
                    icon: 'pi pi-home',
                    items: [
                        {
                            label: await this.getLabel('FASCICLE.NEW_FASCICLE'),
                            icon: 'pi pi-fw pi-plus',
                            routerLink: ['/catalog/' + idCatalog + '/fascicle/new']
                        },
                        {
                            label: await this.getLabel('MENU.FASCICLES'),
                            icon: 'pi pi-fw pi-list',
                            items: fascicles
                        }

                       

                    ]
                },
                {
                    label: this.user.name + " " + this.user.surname,
                    icon: 'pi pi-fw pi-user',
                    items: [
                        {
                            label: 'Cerrar sesión',
                            icon: 'pi pi-fw pi-sign-out',
                            command: () => {
                                this.userService.logOut(this.user);
                                window.location.href = '/login';
                            }

                        },
                    ],
                },
            ];
        });
    }

    getIdCatalogFromUrl(url: string) {
        // Expresión regular para capturar el ID entre 'catalog' y 'fascicles'
        //console.log("Buscar url", url);
        const regex = /\/catalog\/([a-f0-9]{24})\/fascicle/;
        const match = url.match(regex);

        if (match) {
            const id = match[1];  // El ID capturado entre 'catalog' y 'fascicles'
            return id;

        } else {
            return undefined;
        }
    }

}